// Dados e geração de eventos compartilhados entre Events.jsx e UpcomingEvents

export const LOCATION = "Templo PIBG – Mauldin, SC";

export const MONTHS_PT = [
  "Janeiro","Fevereiro","Março","Abril","Maio","Junho",
  "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro",
];

// ─── helpers internos ─────────────────────────────────────────────────────────

function fmtDate(d) {
  return d.toISOString().split("T")[0];
}

function addDays(d, n) {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

function nthWeekdayOfMonth(year, month, n, dow) {
  const d = new Date(year, month, 1);
  let count = 0;
  while (d.getMonth() === month) {
    if (d.getDay() === dow && ++count === n) return new Date(d);
    d.setDate(d.getDate() + 1);
  }
  return null;
}

// ─── geração de eventos ──────────────────────────────────────────────────────

export function buildEvents() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayStr = fmtDate(today);
  const yearEnd = new Date("2026-12-31");
  let id = 1;
  const out = [];

  const add = (ev) => {
    if (ev.date >= todayStr) out.push({ id: id++, location: LOCATION, ...ev });
  };

  // ── ESPECIAIS (não recorrentes) ───────────────────────────────────────────
  [
    {
      title: "Louvorzão",
      date: "2026-06-28", time: "18:30", category: "especiais",
      description: "Culto especial de louvor",
    },
    {
      title: "Acampamento PIB",
      date: "2026-09-04", endDate: "2026-09-07", time: "", category: "especiais",
      description: "Acampamento em Greenwood, SC — 04 a 07 de Setembro",
    },
    {
      title: "Encontro Pais e Filhos",
      date: "2026-09-26", time: "18:30", category: "especiais",
      description: "Encontro especial para pais e filhos",
    },
    {
      title: "Louvorzão",
      date: "2026-09-27", time: "18:30", category: "especiais",
      description: "Culto especial de louvor",
    },
    {
      title: "Dia das Crianças",
      date: "2026-10-11", time: "18:30", category: "infantil",
      description: "Celebração especial do Dia das Crianças",
    },
    {
      title: "Hallelujah Night",
      date: "2026-10-31", time: "18:00", category: "especiais",
      description: "Festa Hallelujah – alternativa cristã ao Halloween",
    },
    {
      title: "Jantar Thanksgiving",
      date: "2026-11-22", time: "18:30", category: "especiais",
      description: "Jantar especial de Ação de Graças",
    },
    {
      title: "Encontro Pais e Filhos",
      date: "2026-12-19", time: "18:30", category: "especiais",
      description: "Encontro especial para pais e filhos",
    },
    {
      title: "Celebração de Natal",
      date: "2026-12-20", time: "18:30", category: "especiais",
      description: "Culto especial de celebração do Natal",
    },
  ].forEach(add);

  // ── MENSAIS ───────────────────────────────────────────────────────────────

  // Brotherhood: 1.º sábado dos meses ímpares — Jul(6), Set(8), Nov(10)
  [6, 8, 10].forEach((m) => {
    const d = nthWeekdayOfMonth(2026, m, 1, 6);
    if (d) add({ title: "Brotherhood", date: fmtDate(d), time: "18:00", category: "especiais", description: "Encontro dos irmãos da PIBG", recurring: "monthly" });
  });

  // SisterHood: 1.º sábado dos meses pares — Jun(5), Ago(7), Out(9), Dez(11)
  [5, 7, 9, 11].forEach((m) => {
    const d = nthWeekdayOfMonth(2026, m, 1, 6);
    if (d) add({ title: "SisterHood", date: fmtDate(d), time: "18:00", category: "mulheres", description: "Encontro das mulheres da PIBG", recurring: "monthly" });
  });

  // Vigília: 3.º sábado de cada mês (Mai=4 … Dez=11)
  for (let m = 4; m <= 11; m++) {
    const d = nthWeekdayOfMonth(2026, m, 3, 6);
    if (d) add({ title: "Vigília", date: fmtDate(d), time: "21:00", category: "especiais", description: "Vigília de oração", recurring: "monthly" });
  }

  // ── SEMANAIS ─────────────────────────────────────────────────────────────
  for (let cur = new Date(today); cur <= yearEnd; cur = addDays(cur, 1)) {
    const dow = cur.getDay();
    const date = fmtDate(cur);

    if (dow === 0) { // Domingo
      add({ title: "Ensaio de Louvor",      date, time: "16:30", category: "culto",      description: "Ensaio do time de louvor", recurring: "weekly" });
      add({ title: "Culto da Família",       date, time: "18:30", category: "culto",      description: "Culto dominical para toda a família", recurring: "weekly" });
    }
    if (dow === 2) { // Terça
      add({ title: "Ensaio Dança Abba Pai",  date, time: "18:30", category: "ministerio", description: "Ensaio do ministério de dança Abba Pai", recurring: "weekly" });
    }
    if (dow === 4) { // Quinta
      add({ title: "Discipulado",            date, time: "19:00", category: "estudo",     description: "Estudo bíblico e discipulado", recurring: "weekly" });
      add({ title: "Círculo de Oração",      date, time: "20:00", category: "estudo",     description: "Momento de intercessão e oração", recurring: "weekly" });
    }
    if (dow === 6) { // Sábado
      add({ title: "Culto Adolescentes",     date, time: "17:00", category: "jovens",     description: "Culto semanal para adolescentes", recurring: "weekly" });
      add({ title: "Culto Jovens",           date, time: "18:00", category: "jovens",     description: "Culto semanal da mocidade", recurring: "weekly" });
    }
  }

  return out.sort((a, b) =>
    a.date !== b.date ? a.date.localeCompare(b.date) : a.time.localeCompare(b.time)
  );
}

// ─── formatters exportados ────────────────────────────────────────────────────

export function formatMonthLabel(key) {
  const [year, month] = key.split("-");
  return `${MONTHS_PT[parseInt(month, 10) - 1]} ${year}`;
}

export function formatDate(dateStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("pt-BR", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });
}

export function formatTime(t) {
  if (!t) return null;
  return t.replace(":00", "h").replace(":30", "h30");
}
